export const ImageMediaTransformationEnum = {
  CLIPPING: 'CLIPPING',
  PLATE_COVER: 'PLATE_COVER'
} as const;

export type ImageMediaTransformationEnum = typeof ImageMediaTransformationEnum[keyof typeof ImageMediaTransformationEnum];

export const MediaAccessControlEnum = {
  PUBLIC: 'PUBLIC',
  USER: 'USER'
} as const;

export type MediaAccessControlEnum = typeof MediaAccessControlEnum[keyof typeof MediaAccessControlEnum];

export const MediaQualityEnum = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
} as const;

export type MediaQualityEnum = typeof MediaQualityEnum[keyof typeof MediaQualityEnum];

export const MediaStatusEnum = {
  ACCEPTED: 'ACCEPTED',
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED',
  DELETED: 'DELETED',
  RESTORED: 'RESTORED',
  RESTORING: 'RESTORING'
} as const;

export type MediaStatusEnum = typeof MediaStatusEnum[keyof typeof MediaStatusEnum];

export const VideoBookmarkTypeEnum = {
  LOW: 'LOW',
  HIGH: 'HIGH'
} as const;

export type VideoBookmarkTypeEnum = typeof VideoBookmarkTypeEnum[keyof typeof VideoBookmarkTypeEnum];

export const VideoMediaTransformationEnum = {
  PRESET_480: 'PRESET_480',
  PRESET_720: 'PRESET_720',
  PRESET_1080: 'PRESET_1080',
  VIDEO_360: 'VIDEO_360'
} as const;

export type VideoMediaTransformationEnum = typeof VideoMediaTransformationEnum[keyof typeof VideoMediaTransformationEnum];

export const VideoQualityEnum = {
  _480: '480',
  _720: '720',
  _1080: '1080'
} as const;

export type VideoQualityEnum = typeof VideoQualityEnum[keyof typeof VideoQualityEnum];
